import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-900/80" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 flex" }
const _hoisted_3 = { class: "absolute left-full top-0 flex w-12 sm:w-16 justify-center pt-3 sm:pt-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close sidebar", -1)
const _hoisted_5 = { class: "flex grow flex-col gap-y-4 sm:gap-y-5 overflow-y-auto bg-parrot px-3 sm:px-4 py-6 sm:py-10 pb-4" }
const _hoisted_6 = { class: "flex flex-1 flex-col" }
const _hoisted_7 = {
  role: "list",
  class: "flex flex-1 flex-col gap-y-7"
}
const _hoisted_8 = {
  role: "list",
  class: "-mx-2 space-y-1"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "mt-auto" }
const _hoisted_11 = { class: "hidden lg:fixed lg:inset-y-0 lg:z-30 lg:mt-14 sm:lg:mt-16 lg:flex lg:w-52 lg:flex-col" }
const _hoisted_12 = { class: "flex grow flex-col gap-y-4 sm:gap-y-5 overflow-y-auto bg-parrot px-3 sm:px-4 py-6 sm:py-10 pb-4" }
const _hoisted_13 = { class: "flex flex-1 flex-col" }
const _hoisted_14 = {
  role: "list",
  class: "flex flex-1 flex-col gap-y-7"
}
const _hoisted_15 = {
  role: "list",
  class: "-mx-2 space-y-1"
}
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "mt-auto" }

import { ref } from "vue";
import { Dialog, TransitionRoot } from "@headlessui/vue";
import { ArrowLeftEndOnRectangleIcon } from "@heroicons/vue/24/outline";
import { useRoute } from "vue-router";
import KeycloakService from "@/security/keycloak-service";
import { navigation } from "@/config/navigation";


export default /*#__PURE__*/_defineComponent({
  __name: 'app-sidebar',
  setup(__props, { expose: __expose }) {

const route = useRoute();
const sidebarOpen = ref(false);

const isActive = (href: string) => {
  return route.path === href;
};

const closeSidebar = () => {
  sidebarOpen.value = false;
};

const logout = () => {
  KeycloakService.callLogOut();
  localStorage.clear();
};

__expose({ sidebarOpen });

return (_ctx: any,_cache: any) => {
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_DialogPanel = _resolveComponent("DialogPanel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: sidebarOpen.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          class: "relative z-50 lg:hidden",
          onClose: _cache[2] || (_cache[2] = ($event: any) => (sidebarOpen.value = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "transition-opacity ease-linear duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "transition-opacity ease-linear duration-300",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "transition ease-in-out duration-300 transform",
                "enter-from": "-translate-x-full",
                "enter-to": "translate-x-0",
                leave: "transition ease-in-out duration-300 transform",
                "leave-from": "translate-x-0",
                "leave-to": "-translate-x-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DialogPanel, { class: "relative mr-16 flex w-full max-w-xs flex-1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_TransitionChild, {
                        as: "template",
                        enter: "ease-in-out duration-300",
                        "enter-from": "opacity-0",
                        "enter-to": "opacity-100",
                        leave: "ease-in-out duration-300",
                        "leave-from": "opacity-100",
                        "leave-to": "opacity-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "-m-2.5 p-2.5",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (sidebarOpen.value = false))
                            }, [
                              _hoisted_4,
                              _createVNode(_component_XMarkIcon, {
                                class: "h-5 w-5 sm:h-6 sm:w-6 text-white",
                                "aria-hidden": "true"
                              })
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("nav", _hoisted_6, [
                          _createElementVNode("ul", _hoisted_7, [
                            _createElementVNode("li", null, [
                              _createElementVNode("ul", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navigation), (item) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: item.name
                                  }, [
                                    _createElementVNode("a", {
                                      href: item.href,
                                      class: _normalizeClass([
                            isActive(item.href)
                              ? 'bg-white bg-opacity-5 text-parrot-1'
                              : 'text-white hover:text-parrot-1 hover:bg-white hover:bg-opacity-5',
                            'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold',
                          ])
                                    }, [
                                      (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                                        class: _normalizeClass([
                              isActive(item.href)
                                ? 'text-parrot-1'
                                : 'text-white group-hover:text-parrot-1',
                              'h-6 w-6 shrink-0',
                            ]),
                                        "aria-hidden": "true"
                                      }, null, 8, ["class"])),
                                      _createTextVNode(" " + _toDisplayString(item.name), 1)
                                    ], 10, _hoisted_9)
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("li", _hoisted_10, [
                              _createElementVNode("a", {
                                href: "#",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (logout())),
                                class: "group -mx-2 flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-white hover:bg-white hover:bg-opacity-5 hover:text-parrot-1"
                              }, [
                                _createVNode(_unref(ArrowLeftEndOnRectangleIcon), {
                                  class: "h-6 w-6 shrink-0 text-white group-hover:text-parrot-1",
                                  "aria-hidden": "true"
                                }),
                                _createTextVNode(" Sair ")
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("nav", _hoisted_13, [
          _createElementVNode("ul", _hoisted_14, [
            _createElementVNode("li", null, [
              _createElementVNode("ul", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navigation), (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.name
                  }, [
                    _createElementVNode("a", {
                      href: item.href,
                      class: _normalizeClass([
                    isActive(item.href)
                      ? 'bg-white bg-opacity-5 text-parrot-1'
                      : 'text-white hover:text-parrot-1 hover:bg-white hover:bg-opacity-5',
                    'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold',
                  ])
                    }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                        color: isActive(item.href) ? '#B2FF59' : 'white',
                        class: _normalizeClass([
                      isActive(item.href)
                        ? 'text-parrot-1'
                        : 'text-white group-hover:text-parrot-1',
                      'h-6 w-6 shrink-0',
                    ]),
                        "aria-hidden": "true"
                      }, null, 8, ["color", "class"])),
                      _createTextVNode(" " + _toDisplayString(item.name), 1)
                    ], 10, _hoisted_16)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("li", _hoisted_17, [
              _createElementVNode("a", {
                href: "#",
                onClick: logout,
                class: "group -mx-2 flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-white hover:bg-white hover:bg-opacity-5 hover:text-parrot-1"
              }, [
                _createVNode(_unref(ArrowLeftEndOnRectangleIcon), {
                  class: "h-6 w-6 shrink-0 text-white group-hover:text-parrot-1",
                  "aria-hidden": "true"
                }),
                _createTextVNode(" Sair ")
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})